import { render, staticRenderFns } from "./DTable.vue?vue&type=template&id=7b561dd6&scoped=true"
import script from "./DTable.vue?vue&type=script&lang=js"
export * from "./DTable.vue?vue&type=script&lang=js"
import style0 from "./DTable.vue?vue&type=style&index=0&id=7b561dd6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b561dd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b561dd6')) {
      api.createRecord('7b561dd6', component.options)
    } else {
      api.reload('7b561dd6', component.options)
    }
    module.hot.accept("./DTable.vue?vue&type=template&id=7b561dd6&scoped=true", function () {
      api.rerender('7b561dd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TkCommonPage/components/DTable.vue"
export default component.exports